import { parseQueryParams } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common';

export enum AuthenticationSource {
  CLASS_LINK = 'CLASS_LINK',
  CLEVER = 'CLEVER',
  GOOGLE = 'GOOGLE',
  LWT = 'LWT',
}

enum sso {
  SSO_LOGIN = 'sso-login',
}

type TQueryParam = {
  authenticationSource?: string;
};

type TWithSSO = [AuthenticationSource | null, { maybeStripParamsAndRedirect: () => void }];

let authenticationSource: AuthenticationSource | null = null;

const getAuthenticationSource = (queryParams) => {
  const authSourceMap = {
    lwt: AuthenticationSource.LWT,
    'class-link': AuthenticationSource.CLASS_LINK,
    google: AuthenticationSource.GOOGLE,
    clever: AuthenticationSource.CLEVER,
  };

  return authSourceMap[queryParams?.authenticationSource] ?? AuthenticationSource.LWT;
};

const useSSO = (): TWithSSO => {
  const location = window.location;
  const queryParams: TQueryParam = parseQueryParams(location.search);

  const maybeStripParamsAndRedirect = () => {
    if (!location.pathname.includes(sso.SSO_LOGIN)) return;
    location.replace(location.origin);
  };

  authenticationSource = authenticationSource || getAuthenticationSource(queryParams);

  return [authenticationSource, { maybeStripParamsAndRedirect }];
};

export default useSSO;
